export type CrsStatus = 'identified' | 'inferred' | 'user-confirmed' | 'unresolved' | 'unsupported';

export const CANONICAL_CRS_IDENTIFIER = 'OGC:CRS84' as const;

export interface CrsMetadata {
  readonly status: CrsStatus;
  readonly identifier?: string;
  readonly name?: string;
  readonly sourceWkt?: string;
  readonly determination?: 'format-specification' | 'declared' | 'inferred' | 'user';
  readonly canonicalIdentifier: typeof CANONICAL_CRS_IDENTIFIER;
  readonly transformation: 'none' | 'reprojected';
}
